<template>
    <div class="container">
        <el-card>
            <div slot="header" class="clearfix">
                <span>历史记录</span>
                <el-button style="float: right; padding: 3px 0" type="text" @click="handleAdd">添加</el-button>
            </div>
            <div v-for="item in remarkHistoryList" :key="item.id">
                <div class="list-container">
                    <el-row type="flex" justify="space-between">
                        <el-col :span="16">
                            <label style="color: #909399"> {{ item.create_time | formatDate }} </label>
                            <label style="color: red;"> {{ item.type | formatSource}}</label>
                        </el-col>

                        <!-- <el-col :span="4">
                          <el-row type="flex" justify="end">
                            {{ getLevelName(item.level) }}
                          </el-row>
                        </el-col> -->

                        <el-col :span="8">
                            <el-row type="flex" justify="end">
                                {{ item.operator }}
                            </el-row>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="16">
                            <el-tooltip effect="dark" :content="item.content" placement="bottom">
                                <div class="text-wrapper">
                                    {{ item.content }}
                                </div>
                            </el-tooltip>
                        </el-col>
                        <el-col :span="8">
                            <el-row type="flex" justify="end">
                                <el-button size="small" type="primary" @click="handleEdit(item)">查看</el-button>
                            </el-row>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </el-card>

        <el-dialog
            :title="isEdit ? '查看' : '新增'"
            :visible.sync="showEditForm"
            :destroy-on-close="true"
            :close-on-click-modal="false"
            @close="handleEditFormDialogClose"
        >

            <el-form ref="editForm" :model="editForm" label-position="right">

<!--                <el-form-item prop="member_id" label="备注人:" label-width="150px">
                    <el-select v-model="editForm.member_id" placeholder="请选择" size="mini" style="width:80%" :disabled="isEdit" >
                        <el-option
                            v-for="item in memberList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>-->

                <!-- <el-form-item prop="level" label="级别:" label-width="150px">
                  <el-input v-model="editForm.level" style="width:50%" />
                </el-form-item> -->

<!--                <el-form-item prop="content" label="类型:" label-width="150px">
                    <el-select v-model="editForm.type" placeholder="请选择" size="mini" style="width:80%" :disabled="isEdit" >
                        <el-option
                            v-for="item in typeOpts"
                            :key="item.key"
                            :label="item.desc"
                            :value="item.key"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>-->
                
                <el-form-item prop="content" label="内容:" label-width="150px">
                    <el-input v-model="editForm.content" type="textarea" :rows="10" style="width:80%" />
                </el-form-item>

            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click="showEditForm = false">取 消</el-button>
                <el-button type="primary" @click="handleSaveAdd">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { format } from "date-fns"
import request from "@/api/request"

const initForm = {
        content: null,
        type: 1
    },

    initRules = {
        type: [
            {
                required: true,
                message: "类型不能为空"
            }
        ],
        content: [
            {
                required: true,
                message: "内容不能为空"
            },
        ],
        member_id: [
            {
                required: true,
                message: "客服不能为空"
            }
        ],
        level: [
            {
                required: true,
                message: "等级不能为空"
            }
        ],
    },
    initSource = [
        {
            value: 1,
            name: '(普通)'
        },
        {
            value: 2,
            name: '(来自待办)'
        }
    ]

export default {
    name: 'HistoryRecord',
    components: {  },
    props: ['remarkHistoryList', 'showEdit'],
    filters: {
        formatDate: (date) => {
            return format(new Date(date), 'yyyy-MM-dd HH:mm:ss')
        },
        formatSource: (value) => {
            const source = initSource.find(item => item.value === value)
            return source ? source.name : ''
        }
    },
    data () {
        return {
            reverse: true,
            typeOpts: [
                {
                    key: 1,
                    desc: '普通'
                },
                {
                    key: 2,
                    desc: '待办'
                }
            ],
            levelList: [
                {
                    key: 0,
                    name: '普通'
                },
                {
                    key: 1,
                    name: '重要'
                },
                {
                    key: 2,
                    name: '非常重要'
                }
            ],
            memberList: [],
            editForm: { ...initForm },
            isEdit: false
        }
    },
    computed: {
        editRules: function () {
            return { ...initRules }
        },
        showEditForm: {
            get() {
                return this.showEdit
            },
            set(v) {
                this.$emit('change-show', v)
            }
        }
    },
    created() {
        this.getMemberList()
    },
    methods: {
        handleAdd() {
            this.isEdit = false
            this.showEditForm = true
        },
        handleEdit(row) {
            this.isEdit = true
            this.editForm = { ...row }
            this.showEditForm = true
        },
        handleSaveAdd() {
            console.log(this.editForm)
            this.$refs.editForm.validate(val => {
                if (val) {
                    this.$emit('change-save', this.editForm)
                }
            })
        },
        handleEditFormDialogClose() {
            this.isEdit = false
            this.editForm = { ...initForm }
            this.$refs.editForm.clearValidate()
        },
        getLevelName(key) {
            let level = this.levelList.find( item => item.key === key )
            return level.name || ''
        },
        getMemberList() {
            request
                .cs
                .post("member_list", {
                    range: [0, 200],
                    filter: { status: 0 }
                }).then(response => {
                this.memberList = []
                if (response.data.list) {
                    response.data.list.forEach(item => this.memberList.push(item))
                }
            })
        },
    }
}
</script>
<style scoped>
.container {
    padding: 0 5px;
}
.clearfix:before,
.clearfix:after {
    display: table;
    content: "";
}
.clearfix:after {
    clear: both
}
.text-wrapper {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    padding-top: 5px;
}
.list-container {
    padding: 10px;
}
</style>
